import React from 'react';
import { Card } from 'react-bootstrap';
import { UserUpdatePasswordForm } from '../../forms/UserUpdatePasswordForm';
import PropTypes from 'prop-types';

export const ChangePassword = ({ user }) => (
  <Card className="bg-white">
    <Card.Header className="border-bottom">
      <Card.Title>Cambiar Contraseña</Card.Title>
    </Card.Header>
    <Card.Body>
      <UserUpdatePasswordForm user={user} />
    </Card.Body>
  </Card>
);
ChangePassword.propTypes = {
  user: PropTypes.object
};
